// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_QuickWinSelectedAnswerRequest } from "@newgenerated/shared/serializerDeserializer/QuickWinSelectedAnswerRequest";

export async function saveQuickWinStarted(props: { body: schema.QuickWinSelectedAnswerRequest; quickWinId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/quickwins/{quickWinId}/ix-status/started";
  path = path.replace(
    "{quickWinId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.quickWinId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_QuickWinSelectedAnswerRequest(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
